/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/interface */
var t=n=>n,e={MAINNET:t("mainnet"),TESTNET:t("testnet"),REGTEST:t("regtest")},i={none:t("none"),mutable:t("mutable"),minting:t("minting")};export{i as NFTCapability,e as Network};
//# sourceMappingURL=interface.mjs.map